import Api from './api.service'

export default {
  create (object) {
    return Api().post('manufacturer/create', object)
  },
  get (id) {
    return Api().get('manufacturer/get/' + id)
  },
  list (filter) {
    return Api().get('manufacturer/get', { params: filter })
  },
  update (object) {
    return Api().put('manufacturer/edit/' + object.id, object.object)
  }
}